<template>
  <div
    class="collection-filter"
    :class="customClass"
  >
    <h2
      class="text-heading-s"
      v-text="$string('collection.filter.label')"
    />
    <template v-if="filters.length > 0">
      <div
        v-for="(filter, index) of filters"
        :key="`quicksearch-filter-${index}`"
        class="collection-filter__options"
      >
        <h3
          class="text-heading-2xl"
          v-text="filter.label"
        />
        <div
          v-for="(option, i) of filter.options"
          :key="`quicksearch-filter-options-${i}`"
          class="collection-filter__option"
        >
          <checkbox-input
            :id="`filter-${index}-option-${i}`"
            :label="getLabel(filter.key, option.name)"
            :value="option.value"
            :checked="option.selected"
            @update:model-value="updateFilter"
            @click="filterKey = filter.key"
          />

          <span
            class="collection-filter__count"
            v-text="`(${option.count})`"
          />
        </div>
      </div>
    </template>
    <p
      v-else
      class="text-heading-xs"
      v-text="$string('collection.filter.no_filter')"
    />
  </div>
</template>

<script>

import CheckboxInput from '~async/utils/checkbox-input/checkbox-input'

/**
 * Vue: Main collection filters (main-collection-filters)
 * -----------------------------------------------------------------------------
 * Main collection filters.
 * - Static section.
 *
 */
export default {
  name: 'MainCollectionFilter',
  components: {
    CheckboxInput,
  },
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    customClass: {
      type: String,
      default: '',
    },
  },

  emits: {
    'update-filters': () => true,
  },

  data() {
    return {
      selectedFilters: [],
      filterKey: '',
    }
  },
mounted(){
  //console.log('filters' , this.filters)
},
  methods: {
    updateFilter(value) {
      this.$emit('update-filters', this.filterKey, value)
    },

    getLabel(key, value) {
      if (key !== 'blade_size' || key !== 'blade_size') {
        return value
      }

      return value.split('|').join(' | ')
    },
  },
}
</script>

<style lang="scss">
@import './main-collection-filters';
</style>
